import { render, staticRenderFns } from "./MessageSendingForm.vue?vue&type=template&id=b5c20bb0&scoped=true&"
import script from "./MessageSendingForm.vue?vue&type=script&lang=ts&"
export * from "./MessageSendingForm.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSendingForm.vue?vue&type=style&index=0&id=b5c20bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c20bb0",
  null
  
)

export default component.exports